import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, vModelText as _vModelText, unref as _unref, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "s16_mobile px-4" }
const _hoisted_2 = { class: "widget px-7 py-7" }
const _hoisted_3 = { class: "s7_mobile container-full-2" }
const _hoisted_4 = { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }
const _hoisted_5 = { class: "s13 flex justify-content-right" }
const _hoisted_6 = { class: "form-field-floating default sm s4_mobile ml-3" }
const _hoisted_7 = {
  key: 0,
  class: "columns-selector-panel"
}
const _hoisted_8 = ["checked", "onChange"]
const _hoisted_9 = { class: "s20 items-center gap-6 px-0 pb-6 collapse-content active" }
const _hoisted_10 = {
  key: 0,
  class: "custom-filter-set-area my-5"
}
const _hoisted_11 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_12 = { class: "form-field-floating sm" }
const _hoisted_13 = { class: "form-field-floating sm" }
const _hoisted_14 = { class: "form-field-floating sm" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "form-field-floating reactive sm" }
const _hoisted_17 = { class: "form-field-floating reactive sm" }
const _hoisted_18 = { class: "form-field-floating reactive sm" }
const _hoisted_19 = { class: "form-field-floating reactive sm" }
const _hoisted_20 = { class: "form-field-floating sm" }
const _hoisted_21 = { class: "form-field-floating sm" }
const _hoisted_22 = { class: "table separator skin3 selection rounded" }
const _hoisted_23 = {
  class: "btn-circle",
  for: "check-list1"
}
const _hoisted_24 = ["checked"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { key: 4 }
const _hoisted_30 = { key: 5 }
const _hoisted_31 = { key: 6 }
const _hoisted_32 = { key: 7 }
const _hoisted_33 = { key: 8 }
const _hoisted_34 = { key: 9 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  colspan: "12",
  class: "text-center py-5"
}
const _hoisted_37 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "selection-item" }
const _hoisted_40 = ["for"]
const _hoisted_41 = ["id", "value"]
const _hoisted_42 = {
  key: 0,
  class: "flex"
}
const _hoisted_43 = {
  key: 1,
  class: "text-xl font-semibold",
  style: {"width":"15%"}
}
const _hoisted_44 = {
  key: 2,
  class: "text-xl font-semibold"
}
const _hoisted_45 = {
  key: 3,
  class: "text-xl font-semibold"
}
const _hoisted_46 = {
  key: 4,
  class: "text-xl font-semibold"
}
const _hoisted_47 = {
  key: 5,
  class: "text-xl font-semibold"
}
const _hoisted_48 = {
  key: 6,
  class: "text-xl font-semibold"
}
const _hoisted_49 = {
  key: 7,
  class: "text-xl font-semibold"
}
const _hoisted_50 = { class: "mt-1" }
const _hoisted_51 = { key: 8 }
const _hoisted_52 = { class: "text-xl font-semibold mb-2" }
const _hoisted_53 = {
  key: 0,
  class: "tag-state warning stroke"
}
const _hoisted_54 = {
  key: 1,
  class: "tag-state success stroke"
}
const _hoisted_55 = {
  key: 2,
  class: "tag-state danger stroke"
}
const _hoisted_56 = { key: 9 }
const _hoisted_57 = { class: "text-xl font-semibold" }
const _hoisted_58 = { style: {"width":"25%"} }
const _hoisted_59 = { class: "flex-right gap-4" }
const _hoisted_60 = { class: "s4 pl-5 pr-7" }
const _hoisted_61 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_62 = { class: "single-chart s6" }
const _hoisted_63 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_64 = ["stroke-dasharray"]
const _hoisted_65 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_66 = { class: "s14 px-4" }
const _hoisted_67 = { class: "font-medium" }
const _hoisted_68 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_69 = { class: "single-chart s6" }
const _hoisted_70 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_71 = ["stroke-dasharray"]
const _hoisted_72 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_73 = { class: "s14 px-4" }
const _hoisted_74 = { class: "font-medium" }
const _hoisted_75 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_76 = { class: "single-chart s6" }
const _hoisted_77 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_78 = ["stroke-dasharray"]
const _hoisted_79 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_80 = { class: "s14 px-4" }
const _hoisted_81 = { class: "font-medium" }
const _hoisted_82 = { class: "w-100 margin-auto mb-5 widget flex-center rounded-15" }
const _hoisted_83 = { class: "single-chart s6" }
const _hoisted_84 = {
  viewBox: "0 0 36 36",
  class: "circular-chart statorange"
}
const _hoisted_85 = ["stroke-dasharray"]
const _hoisted_86 = {
  x: "18",
  y: "20.35",
  class: "percentage font-bold"
}
const _hoisted_87 = { class: "s14 px-4" }
const _hoisted_88 = { class: "font-medium" }

import { computed, inject, onBeforeUnmount, onMounted, reactive, Ref, ref, watch } from 'vue';
    import CollectivitesManagementProspectsImportModal from './CollectivitesManagementProspectsImportModal.vue';
    import axios from 'axios';
    import moment from 'moment';
    import { calculatePercentage, formatAmount, formatDate } from '@/utils';
    import { useToastStore } from '@/stores/toast.store';
    import { useConfirmationStore } from '@/stores/confirmation.store';
    import { useRoute } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesManagementProspects',
  setup(__props) {

    const route = useRoute();
    const toastStore = useToastStore();
    const startupInfos = reactive<{ salaires: any[] }>(route.meta.item as any);
    const confirmationStore = useConfirmationStore();
    const loading = ref(false);
    const loadingActions = ref(false);
    const errorMessage = ref('');
    const prospectsImportModal = ref<InstanceType<typeof CollectivitesManagementProspectsImportModal> | null>(null);
    const collectivite = inject<Ref<any>>('collectivite');
    const itemsList = ref<any[]>([]);
    const filteredDatas = ref([] as Array<any>);
    const paginatedFilteredDatas = ref([] as Array<any>);
    const queryParams = reactive({
        pageNumber: 1
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const filtersParams = reactive({
        name: '',
        statut_professionnel: null,
        salaires: null,
        quotite_cessible_min: null,
        quotite_cessible_max: null,
        age_min: null,
        age_max: null,
        sexe: null,
        fonction: null,
        statut_prospect: null
    });
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return paginatedFilteredDatas.value.length > 0 && selectedItems.value.filter(i => paginatedFilteredDatas.value.findIndex(p => p.id === i) !== -1).length === paginatedFilteredDatas.value.length;
    });
    const areAllItemsSelectedValidable = computed(() => {
        return selectedItems.value.length > 0 && countItemsSelectedValidable.value === selectedItems.value.length;
    });
    const countItemsSelectedValidable = computed(() => {
        return itemsList.value.filter(i => selectedItems.value.includes(i.id) && i.statut_prospect == 0).length;
    });
    const showAdvancedFilters = ref(false);

    const columnsCatalog = [
        { key: 'photo', label: 'Photo' },
        { key: 'information', label: 'Information' },
        { key: 'date_naissance', label: 'Date de naissance', hidden: true },
        { key: 'age', label: 'Age', hidden: true },
        { key: 'sexe', label: 'Sexe', hidden: true },
        { key: 'retraite', label: 'Retraite', hidden: true },
        { key: 'salaire', label: 'Salaire' },
        { key: 'utilisation', label: 'Utilisation' },
        { key: 'statut', label: 'Statut' },
        { key: 'contact', label: 'Contact' }
    ];
    const visibleColumns = ref(columnsCatalog.filter(c => c.hidden === undefined || c.hidden === false).map(c => c.key));
    const showColumnsSelector = ref(false);
    const columnsSelectorRef = ref<HTMLElement | null>(null);

    const statsPersonnesActivesCount = computed(() => itemsList.value.filter(i => !i.retraite).length);
    const statsPersonnesActivesPercent = computed(() => {
        if (itemsList.value.length == 0) { return 0; }
        return Math.round((statsPersonnesActivesCount.value * 100) / itemsList.value.length);
    });

    const statsPersonnesRetraitesCount = computed(() => itemsList.value.filter(i => i.retraite).length);
    const statsPersonnesRetraitesPercent = computed(() => {
        if (itemsList.value.length == 0) { return 0; }
        return Math.round((statsPersonnesRetraitesCount.value * 100) / itemsList.value.length);
    });

    const statsPersonnesHommesCount = computed(() => itemsList.value.filter(i => i.sexe == 'M').length);
    const statsPersonnesHommesPercent = computed(() => {
        if (itemsList.value.length == 0) { return 0; }
        return Math.round((statsPersonnesHommesCount.value * 100) / itemsList.value.length);
    });

    const statsPersonnesFemmesCount = computed(() => itemsList.value.filter(i => i.sexe == 'F').length);
    const statsPersonnesFemmesPercent = computed(() => {
        if (itemsList.value.length == 0) { return 0; }
        return Math.round((statsPersonnesFemmesCount.value * 100) / itemsList.value.length);
    });

    onMounted(() => {
        fetchProspects();
        document.addEventListener('click', handleClickOutsideColumnsSelector);
    });

    onBeforeUnmount(() => {
        document.removeEventListener('click', handleClickOutsideColumnsSelector);
    });

    watch(filtersParams, (oldValues, newValues) => {
        applyFilters();
        onPaginate(1);
    });

    async function fetchProspects(withoutLoading?: boolean) {
        try {
            if (!withoutLoading) { loading.value = true; }
            const response = await axios.get(`/backoffice/collectivites/${collectivite?.value.id}/prospects`);
            itemsList.value = response.data;
            applyFilters();
            onPaginate(1);
        } catch(error: any) {
            toastStore.error(error.message || 'Une erreur est survenue lors de la requête au serveur.');
        } finally {
            loading.value = false;
        }
    }

    async function openProspectsImportModal() {
        if (prospectsImportModal.value && collectivite) {
            const result = await prospectsImportModal.value.open(collectivite.value);
            if (result) {
                fetchProspects();
            }
        }
    }

    async function validateSelectedProspects(prospectsIds: number[]) {
        const confirmation = await confirmationStore.open('Validation des prospects', `Êtes-vous sûr de vouloir valider ${prospectsIds.length > 1 ? `les ${prospectsIds.length} prospects sélectionnés` : `le prospect sélectionné`} ?`);
        if (!confirmation) return;
        selectedItems.value = prospectsIds;

        try {
            loadingActions.value = true;
            await axios.post(`/backoffice/collectivites/${collectivite?.value.id}/prospects/validate`, { ids: prospectsIds });
            await fetchProspects(true);
            selectedItems.value = [];
            toastStore.success("Action enregistrée");
        } catch(error: any) { 
            toastStore.error(error.message || 'Une erreur est survenue lors de la validation des prospects.');
        } finally {
            loadingActions.value = false;
        }
    }

    async function rejectSelectedProspects(prospectsIds: number[]) {
        const confirmation = await confirmationStore.open('Rejet des prospects', `Êtes-vous sûr de vouloir rejeter ${prospectsIds.length > 1 ? `les ${prospectsIds.length} prospects sélectionnés` : `le prospect sélectionné`} ?`);
        if (!confirmation) return;
        selectedItems.value = prospectsIds;

        try {
            loadingActions.value = true;
            await axios.post(`/backoffice/collectivites/${collectivite?.value.id}/prospects/reject`, { ids: prospectsIds });
            await fetchProspects(true);
            selectedItems.value = [];
            toastStore.success("Action enregistrée");
        } catch(error: any) {
            toastStore.error(error.message || 'Une erreur est survenue lors du rejet des prospects.');
        } finally {
            loadingActions.value = false;
        }
    }

    function applyFilters() {
        let allDatas = itemsList.value;

        if (filtersParams.name) {
            allDatas = allDatas.filter(a => `${a.nom} ${a.prenom}`.toLowerCase().includes(filtersParams.name.toLowerCase()));
        }
        if (filtersParams.statut_prospect) {
            allDatas = allDatas.filter(a => a.statut_prospect == filtersParams.statut_prospect)
        }
        if (filtersParams.statut_professionnel) {
            if (filtersParams.statut_professionnel == '1') {
                allDatas = allDatas.filter(a => a.retraite === false);
            } else if (filtersParams.statut_professionnel == '2') {
                allDatas = allDatas.filter(a => a.retraite === true);
            }
        }
        if (filtersParams.sexe) {
            allDatas = allDatas.filter(a => a.sexe == filtersParams.sexe);
        }
        if (filtersParams.quotite_cessible_min != null && !isNaN(filtersParams.quotite_cessible_min)) {
            const quotite_cessible_min = parseFloat(filtersParams.quotite_cessible_min);
            allDatas = allDatas.filter(a => a.quotite_cessible_montant && !isNaN(a.quotite_cessible_montant) && a.quotite_cessible_montant >= quotite_cessible_min);
        }
        if (filtersParams.quotite_cessible_max != null && !isNaN(filtersParams.quotite_cessible_max)) {
            const quotite_cessible_max = parseFloat(filtersParams.quotite_cessible_max);
            allDatas = allDatas.filter(a => a.quotite_cessible_montant && !isNaN(a.quotite_cessible_montant) && a.quotite_cessible_montant <= quotite_cessible_max);
        }
        if (filtersParams.age_min) {
            const age_min = moment(filtersParams.age_min);
            if (age_min.isValid()) {
                allDatas = allDatas.filter(a => {
                    const date_naissance = moment(a.date_naissance);
                    return date_naissance.isValid() && date_naissance.isSameOrAfter(age_min);
                })
            }
        }
        if (filtersParams.age_max) {
            const age_max = moment(filtersParams.age_max);
            if (age_max.isValid()) {
                allDatas = allDatas.filter(a => {
                    const date_naissance = moment(a.date_naissance);
                    return date_naissance.isValid() && date_naissance.isSameOrBefore(age_max);
                })
            }
        }
        if (filtersParams.salaires != null) {
            const matchSalaire = startupInfos.salaires[filtersParams.salaires];
            if (matchSalaire) {
                allDatas = allDatas.filter(a => !isNaN(a.salaire) && parseFloat(a.salaire) >= parseFloat(matchSalaire.salaire_min) && parseFloat(a.salaire) <= parseFloat(matchSalaire.salaire_max));
            }
        }
        
        filteredDatas.value = allDatas;
    }

    function onPaginate(page: number) {
        queryParams.pageNumber = page;
        pagination.total = filteredDatas.value.length;
        pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
        const start = (page - 1) * pagination.per_page;
        paginatedFilteredDatas.value =  filteredDatas.value.slice(start, start + pagination.per_page);
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = [...selectedItems.value.filter(s => itemsList.value.findIndex(p => p.id === s) === -1), ...itemsList.value.map(i => i.id)];
        } else {
            selectedItems.value = [];
        }
    }

    function toggleAdvancedFilters() {
        showAdvancedFilters.value = !showAdvancedFilters.value;
    }

    function isColumnVisible(key: string) {
        return visibleColumns.value.includes(key);
    }

    function toggleColumn(key: string) {
        const index = visibleColumns.value.indexOf(key);
        if (index === -1) {
            visibleColumns.value.push(key);
        } else if (visibleColumns.value.length > 1) {
            visibleColumns.value.splice(index, 1);
        }
    }

    function toggleColumnsSelector() {
        showColumnsSelector.value = !showColumnsSelector.value;
    }

    function handleClickOutsideColumnsSelector(event: MouseEvent) {
        if (columnsSelectorRef.value && !columnsSelectorRef.value.contains(event.target as Node)) {
            showColumnsSelector.value = false;
        }
    }


return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, [
            _cache[14] || (_cache[14] = _createElementVNode("img", {
              src: "/icons/icon-info-perso.svg",
              class: "size-l",
              alt: ""
            }, null, -1)),
            _createTextVNode(" Prospects (" + _toDisplayString(filteredDatas.value.length) + ") ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (areAllItemsSelectedValidable.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_custom_button, {
                  type: "button",
                  classesList: 'btn danger',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (rejectSelectedProspects(selectedItems.value))),
                  loading: loadingActions.value
                }, {
                  default: _withCtx(() => [
                    _cache[15] || (_cache[15] = _createElementVNode("img", {
                      src: "/icons/icon-delete.svg",
                      class: "btn-icon icon-white",
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("span", null, "Rejeter (" + _toDisplayString(countItemsSelectedValidable.value) + ")", 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_custom_button, {
                  type: "button",
                  classesList: 'btn',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (validateSelectedProspects(selectedItems.value))),
                  loading: loadingActions.value
                }, {
                  default: _withCtx(() => [
                    _cache[16] || (_cache[16] = _createElementVNode("img", {
                      src: "/icons/icon-valider.svg",
                      class: "btn-icon",
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("span", null, "Valider (" + _toDisplayString(countItemsSelectedValidable.value) + ")", 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_custom_button, {
            type: "button",
            classesList: 'btn normal ml-4 justify-content-center btn-filtre',
            onClick: openProspectsImportModal
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createElementVNode("img", {
                src: "/icons/icon-add.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Importer des prospects", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_custom_button, {
            type: "button",
            classesList: 'btn light',
            onClick: fetchProspects
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createElementVNode("img", {
                src: "/icons/icon-list.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Actualiser", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("select", {
              class: "form-input-select",
              name: "statut_prospect",
              id: "statut_prospect",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtersParams.statut_prospect) = $event))
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("option", { value: null }, "Tous les prospects", -1),
              _createElementVNode("option", { value: "1" }, "Prospects validés", -1),
              _createElementVNode("option", { value: "-1" }, "Prospects refusés", -1)
            ]))], 512), [
              [_vModelSelect, filtersParams.statut_prospect]
            ])
          ]),
          _createElementVNode("button", {
            class: "btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter",
            onClick: toggleAdvancedFilters
          }, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("img", {
              src: "/icons/icon-filter.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Options", -1)
          ]))]),
          _createElementVNode("div", {
            class: "columns-selector s3_mobile ml-4",
            ref_key: "columnsSelectorRef",
            ref: columnsSelectorRef
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn normal justify-content-center white2 btn-filtre btn-filter",
              onClick: toggleColumnsSelector
            }, [...(_cache[21] || (_cache[21] = [
              _createElementVNode("img", {
                src: "/icons/icon-list.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Colonnes", -1)
            ]))]),
            (showColumnsSelector.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columnsCatalog, (col) => {
                    return _createElementVNode("label", {
                      class: "columns-selector-item",
                      key: col.key
                    }, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: isColumnVisible(col.key),
                        onChange: ($event: any) => (toggleColumn(col.key))
                      }, null, 40, _hoisted_8),
                      _createElementVNode("span", null, _toDisplayString(col.label), 1)
                    ])
                  }), 64))
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ]),
        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
        _createElementVNode("div", _hoisted_9, [
          (showAdvancedFilters.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filtersParams.name) = $event)),
                      name: "name",
                      id: "name",
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, filtersParams.name]
                    ]),
                    _cache[22] || (_cache[22] = _createElementVNode("label", { for: "name" }, "Rechercher", -1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filtersParams.statut_professionnel) = $event)),
                      name: "statut_professionnel",
                      id: "statut_professionnel"
                    }, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("option", { value: null }, "Tous les statuts", -1),
                      _createElementVNode("option", { value: "1" }, "Actifs", -1),
                      _createElementVNode("option", { value: "2" }, "Retraités", -1)
                    ]))], 512), [
                      [_vModelSelect, filtersParams.statut_professionnel]
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("label", { for: "statut_professionnel" }, [
                      _createTextVNode("Statut "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filtersParams.salaires) = $event)),
                      name: "salaires",
                      id: "salaires"
                    }, [
                      _cache[25] || (_cache[25] = _createElementVNode("option", { value: null }, "Tous les salaires", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.salaires, (salaire, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: index,
                          key: index
                        }, _toDisplayString(_unref(formatAmount)(salaire.salaire_min) + ' - ' + _unref(formatAmount)(salaire.salaire_max)), 9, _hoisted_15))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, filtersParams.salaires]
                    ]),
                    _cache[26] || (_cache[26] = _createElementVNode("label", { for: "salaires" }, [
                      _createTextVNode("Salaires "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filtersParams.quotite_cessible_min) = $event)),
                      name: "quotite_cessible_min",
                      id: "quotite_cessible_min",
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, filtersParams.quotite_cessible_min]
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("label", { for: "quotite_cessible_min" }, "Quotité cessible >=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filtersParams.quotite_cessible_max) = $event)),
                      name: "quotite_cessible_max",
                      id: "quotite_cessible_max",
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, filtersParams.quotite_cessible_max]
                    ]),
                    _cache[28] || (_cache[28] = _createElementVNode("label", { for: "quotite_cessible_max" }, "Quotité cessible <=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filtersParams.age_min) = $event)),
                      name: "age_min",
                      id: "age_min",
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, filtersParams.age_min]
                    ]),
                    _cache[29] || (_cache[29] = _createElementVNode("label", { for: "age_min" }, "Age >=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-input",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filtersParams.age_max) = $event)),
                      name: "age_max",
                      id: "age_max",
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, filtersParams.age_max]
                    ]),
                    _cache[30] || (_cache[30] = _createElementVNode("label", { for: "age_max" }, "Age <=", -1))
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filtersParams.sexe) = $event)),
                      name: "sexe",
                      id: "sexe"
                    }, [...(_cache[31] || (_cache[31] = [
                      _createElementVNode("option", { value: null }, "Tous les sexes", -1),
                      _createElementVNode("option", { value: "M" }, "Masculin", -1),
                      _createElementVNode("option", { value: "F" }, "Féminin", -1)
                    ]))], 512), [
                      [_vModelSelect, filtersParams.sexe]
                    ]),
                    _cache[32] || (_cache[32] = _createElementVNode("label", { for: "sexe" }, [
                      _createTextVNode("Sexe "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-input-select",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((filtersParams.fonction) = $event)),
                      name: "fonction",
                      id: "fonction"
                    }, [...(_cache[33] || (_cache[33] = [
                      _createElementVNode("option", { value: null }, "Toutes les fonctions", -1)
                    ]))], 512), [
                      [_vModelSelect, filtersParams.fonction]
                    ]),
                    _cache[34] || (_cache[34] = _createElementVNode("label", { for: "fonction" }, [
                      _createTextVNode("Fonction "),
                      _createElementVNode("b", { class: "color-danger" }, "*")
                    ], -1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_22, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("label", _hoisted_23, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "check_all",
                      checked: areAllItemsSelected.value,
                      onChange: handleCheckAll
                    }, null, 40, _hoisted_24)
                  ])
                ]),
                (isColumnVisible('photo'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_25))
                  : _createCommentVNode("", true),
                (isColumnVisible('information'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_26, [...(_cache[35] || (_cache[35] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Information", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('date_naissance'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_27, [...(_cache[36] || (_cache[36] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Date de naissance", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('age'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_28, [...(_cache[37] || (_cache[37] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Age", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('sexe'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_29, [...(_cache[38] || (_cache[38] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Sexe", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('retraite'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_30, [...(_cache[39] || (_cache[39] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Retraite", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('salaire'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_31, [...(_cache[40] || (_cache[40] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Salaire", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('utilisation'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_32, [...(_cache[41] || (_cache[41] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Utilisation", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('statut'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_33, [...(_cache[42] || (_cache[42] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Statut", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (isColumnVisible('contact'))
                  ? (_openBlock(), _createElementBlock("th", _hoisted_34, [...(_cache[43] || (_cache[43] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-filter-up.svg",
                        class: "size-xxs mt--1",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Contact", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _cache[44] || (_cache[44] = _createElementVNode("th", { class: "flex-right" }, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                    _createElementVNode("td", _hoisted_36, [
                      (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[45] || (_cache[45] = [
                            _createElementVNode("div", { class: "loader dark" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (paginatedFilteredDatas.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [...(_cache[46] || (_cache[46] = [
                      _createElementVNode("td", {
                        colspan: "12",
                        class: "text-center py-5"
                      }, " Aucun prospect trouvé ", -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(paginatedFilteredDatas.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "text-grey-700 over-effect",
                        key: 'item_' + index
                      }, [
                        _createElementVNode("td", _hoisted_39, [
                          _createElementVNode("label", {
                            class: "btn-circle",
                            for: 'item_check_' + index
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "selectedItems[]",
                              id: 'item_check_' + index,
                              value: item.id,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedItems).value = $event))
                            }, null, 8, _hoisted_41), [
                              [_vModelCheckbox, selectedItems.value]
                            ])
                          ], 8, _hoisted_40)
                        ]),
                        (isColumnVisible('photo'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_42, [...(_cache[47] || (_cache[47] = [
                              _createElementVNode("div", {
                                class: "square-xl rounded-15 ml-3",
                                style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
                              }, [
                                _createElementVNode("img", {
                                  src: "/assets/users/300w/user.jpg",
                                  width: "100%"
                                })
                              ], -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (isColumnVisible('information'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(item.nom + ' ' + item.prenom), 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('date_naissance'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_44, _toDisplayString(_unref(formatDate)(item.date_naissance, 'DD/MM/YYYY')), 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('age'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(item.age), 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('sexe'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_46, _toDisplayString(item.sexe), 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('retraite'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_47, _toDisplayString(item.retraite ? 'Oui' : 'Non'), 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('salaire'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_48, _toDisplayString(_unref(formatAmount)(item.salaire)) + " F ", 1))
                          : _createCommentVNode("", true),
                        (isColumnVisible('utilisation'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_49, [
                              _createTextVNode(_toDisplayString(item.quotite_cessible_pourcent) + "% ", 1),
                              _createElementVNode("p", _hoisted_50, _toDisplayString(_unref(formatAmount)(item.quotite_cessible_montant)) + " F", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (isColumnVisible('statut'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_51, [
                              _createElementVNode("p", _hoisted_52, [
                                (item.statut_prospect == 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_53, "En attente"))
                                  : _createCommentVNode("", true),
                                (item.statut_prospect == 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, "Validé"))
                                  : _createCommentVNode("", true),
                                (item.statut_prospect == -1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, "Rejeté"))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (isColumnVisible('contact'))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_56, [
                              _createElementVNode("span", _hoisted_57, _toDisplayString(item.telephone), 1),
                              _cache[48] || (_cache[48] = _createTextVNode()),
                              _cache[49] || (_cache[49] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(item.email), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_router_link, {
                              to: '/app/prospects/' + item.id + '/simulation'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_custom_button, {
                                  type: "button",
                                  classesList: 'btn-ultra light'
                                }, {
                                  default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                    _createElementVNode("span", null, "Simulation", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["to"]),
                            (item.statut_prospect == 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_custom_button, {
                                    type: "button",
                                    classesList: 'btn-ultra danger',
                                    onClick: ($event: any) => (rejectSelectedProspects([item.id])),
                                    loading: loadingActions.value && selectedItems.value.findLastIndex(s => s == item.id) > -1
                                  }, {
                                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                      _createElementVNode("img", {
                                        src: "/icons/icon-delete.svg",
                                        class: "btn-icon icon-white",
                                        alt: ""
                                      }, null, -1),
                                      _createElementVNode("span", null, "Rejeter", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick", "loading"]),
                                  _createVNode(_component_custom_button, {
                                    type: "button",
                                    classesList: 'btn-ultra',
                                    onClick: ($event: any) => (validateSelectedProspects([item.id])),
                                    loading: loadingActions.value && selectedItems.value.findLastIndex(s => s == item.id) > -1
                                  }, {
                                    default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                      _createElementVNode("img", {
                                        src: "/icons/icon-valider.svg",
                                        class: "btn-icon",
                                        alt: ""
                                      }, null, -1),
                                      _createElementVNode("span", null, "Valider", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick", "loading"])
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
            ])
          ]),
          _createVNode(_component_custom_pagination, {
            modelValue: queryParams.pageNumber,
            "onUpdate:modelValue": [
              _cache[13] || (_cache[13] = ($event: any) => ((queryParams.pageNumber) = $event)),
              onPaginate
            ],
            total: pagination.total,
            "per-page": pagination.per_page,
            last_page: pagination.last_page
          }, null, 8, ["modelValue", "total", "per-page", "last_page"])
        ]),
        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "clear-both" }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          (_openBlock(), _createElementBlock("svg", _hoisted_63, [
            _cache[55] || (_cache[55] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray": statsPersonnesActivesPercent.value + ', 100',
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_64),
            _createElementVNode("text", _hoisted_65, _toDisplayString(statsPersonnesActivesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("h3", _hoisted_67, _toDisplayString(statsPersonnesActivesCount.value), 1),
          _cache[56] || (_cache[56] = _createElementVNode("h6", { class: "font-medium" }, "Personnes actives", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          (_openBlock(), _createElementBlock("svg", _hoisted_70, [
            _cache[57] || (_cache[57] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray":  statsPersonnesRetraitesPercent.value + ', 100',
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_71),
            _createElementVNode("text", _hoisted_72, _toDisplayString(statsPersonnesRetraitesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("h3", _hoisted_74, _toDisplayString(statsPersonnesRetraitesCount.value), 1),
          _cache[58] || (_cache[58] = _createElementVNode("h6", { class: "font-medium" }, "Personnes retraités", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_75, [
        _createElementVNode("div", _hoisted_76, [
          (_openBlock(), _createElementBlock("svg", _hoisted_77, [
            _cache[59] || (_cache[59] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray": statsPersonnesHommesPercent.value + ', 100',
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_78),
            _createElementVNode("text", _hoisted_79, _toDisplayString(statsPersonnesHommesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("h3", _hoisted_81, _toDisplayString(statsPersonnesHommesCount.value), 1),
          _cache[60] || (_cache[60] = _createElementVNode("h6", { class: "font-medium" }, "Hommes", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          (_openBlock(), _createElementBlock("svg", _hoisted_84, [
            _cache[61] || (_cache[61] = _createElementVNode("path", {
              class: "circle-bg",
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, -1)),
            _createElementVNode("path", {
              class: "circle",
              "stroke-dasharray": statsPersonnesFemmesPercent.value + ', 100',
              d: "M18 2.0845\n                    a 15.9155 15.9155 0 0 1 0 31.831 \n                    a 15.9155 15.9155 0 0 1 0 -31.831"
            }, null, 8, _hoisted_85),
            _createElementVNode("text", _hoisted_86, _toDisplayString(statsPersonnesFemmesPercent.value) + "%", 1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("h3", _hoisted_88, _toDisplayString(statsPersonnesFemmesCount.value), 1),
          _cache[62] || (_cache[62] = _createElementVNode("h6", { class: "font-medium" }, "Femmes", -1))
        ])
      ])
    ]),
    _createVNode(CollectivitesManagementProspectsImportModal, {
      ref_key: "prospectsImportModal",
      ref: prospectsImportModal
    }, null, 512)
  ], 64))
}
}

})